import React from "react";
import { apiCurrentVacancy } from '../../services/apis/retail/apiCurrentVacancy'

class CurrentVacancy extends React.Component {
    state = {
        areaActual: 0,
        areaPerc: 0
    }

    componentDidMount() {
        apiCurrentVacancy.get().then((res) => {
            this.setState({ areaActual: res.data.area_actual, areaPerc: res.data.area_perc });
        });
    }

    render() {
        return (
            <div className="widget">
                <div className="row">
                    <div className="col-lg-4 flexCenter">
                        <img
                            alt="Current Vacancy Icon"
                            src="/edge/images/current_vacancy.png"
                            className="imgWidth100"
                        />
                    </div>
                    <div className="col-lg-8 text-start colorDarkBlue">
                        <h1>{this.state.areaPerc} %</h1>
                        <p>({this.state.areaActual} msf)</p>
                    </div>
                </div>
                <p className="widgetName">Current Vacancy</p>
            </div>
        );
    }
}

export default CurrentVacancy;
